import React, { useState, useEffect } from "react";
import { Header } from '../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import CasinoSuperbombaBanner from "../../Components/Casino/CasinoSuperbomba/CasinoSuperbombaBanner.jsx";
import CasinoSuperbombaResults from "../../Components/Casino/CasinoSuperbomba/CasinoSuperbombaResults.jsx";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import { GameDetails } from "../../Components/Game/GameDetails.jsx";

export default function BonusesCasinoSuperbomba(props) {

    const [state, setState] = useState({
        info: null,
        results: [],
        rewards: [],
        resultsLoaded: false,
        hasScrolledToRewards: false,
        isFinished: null
    });

    const { kampanja } = useParams();

    var smallBombsStart = 0;


    useEffect(() => {
        window.scrollTo(0, 0);
        props.showMenuFn(false);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Superbomba', 'casino', props.user);
        getData();

        return (() => {
            props.showLoadingFn(false);
        })
    }, []);

    useEffect(() => {
        const hash = window.location.hash;

        if (!state.hasScrolledToRewards && state.resultsLoaded && (hash === "#rewards" || hash === "#games")) {
            const el = document.querySelector(hash);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: "smooth" });
                    setState(prev => ({ ...prev, hasScrolledToRewards: true }));
                }, 300);
            }
        }
    }, [state.resultsLoaded, state.hasScrolledToRewards]);

    function getData() {
        props.showLoadingFn(true);

        var promises = Promise.all([
            casino.repos.gameRepo.list().then(props.unpackGamesListFn),
            casino.repos.categoryRepo.list().then(props.saveCategoriesFn),
            casino.repos.casinoSuperbombaRepo.get(kampanja ? kampanja : "1")]);
        var dataPromises = casino.utils.makeCancelablePromise(promises);
        dataPromises.promise.then(setData, function (reason) { });
    }

    function setData(data) {
        props.showLoadingFn(false);
        var [games, gameCategories, res] = data;

        //EGT Digital Halloween
        const gameIdsString = res.info.igreSifre;
        const gameIdsArray = gameIdsString.split(',');

        const gameIdMap = {};
        games.forEach(game => {
            gameIdMap[game.s] = game;
        });

        // Use this for 
        const sortedGames = gameIdsArray
            .map(id => gameIdMap[id])
            .filter(game => game !== undefined)
            .filter((value, index, self) => self.indexOf(value) === index);

        setState({
            ...state,
            info: res.info,
            results: res.rezultati,
            rewards: res.nagrade,
            resultsLoaded: true,
            activePlayers: res.activePlayers,
            isFinished: new Date().getTime() > new Date(res.info.aktivnoDo).getTime(),
            games: sortedGames, // EGT Digital Halloween - change to games for other promotions
            gameCategories: gameCategories.items
        });
    }

    function renderRewards() {
        let smallBombs = state.rewards.filter(x => x.nagrada < smallBombsStart);
        let nagradniFond = 0;
        state.rewards.forEach(bomb => nagradniFond += (bomb.brojBomba * bomb.nagrada));

        let pravila;
        let nagrada;
        switch (kampanja) {
            case 'multi-2025-07':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_RedTiger_NetEnt_BTG_NoLimitCity_14_7_2025.pdf`;
                nagrada = "5.000,00 €";
                break;
            case 'synot-2025-07':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Synot_25_7_2025.pdf`;
                nagrada = "12.000,00 €";
                break;
            case 'egt-digital-2025-08':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_11_8_2025.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'tech4bet-2025-08':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Tech4Bet_18_8_2025.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'gamesglobal-2025-08':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_GamesGlobal_22_8_2025.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'endorphina-2025-10':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Endorphina_6_10_2025.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'fazi-2025-10':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Fazi_15_10_2025.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'fazi-2025-10':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Fazi_15_10_2025.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'egt-digital-2025-11':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_3_11_2025.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'gamesglobal-2025-11':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_GamesGlobal_10_11_2025.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'egt-digital-2025-11-2':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_17_11_2025.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'amusnet-2025-11':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Amusnet_24_11_2025.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'egt-digital-2025-12':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_1_12_2025.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'egt-digital-2025-12-2':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_7_12_2025.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'pragmatic-2025-12':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_PragmaticPlay_11_12_2025.pdf`;
                nagrada = "70.000,00 €";
                break;
            case 'fazi-2025-12':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Fazi_15_12_2025.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'gamesglobal-2025-12':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_GamesGlobal_19_12_2025.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'playn-go-2025-12':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_PlayNGo_22_12_2025.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'egt-digital-2026-01-1':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGT_Digital_05_01_2026.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'egt-digital-2026-01-2':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_12_1_2026.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'greentube-2026-01':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Greentube_16_1_2026.pdf`;
                nagrada = "40.000,00 €";
                break;
            case '7777gaming-2026-01':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_7777Gaming_23_1_2026.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'egt-digital-2026-02-1':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_2_2_2026.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'playn-go-2026-02':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_PlaynGo_12_2_2026.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'egt-digital-2026-03':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_2_3_2026.pdf`;
                nagrada = "20.000,00 €";
                break;
            case 'evona-2026-03':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Evona_9_3_2026.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'amusnet-2026-03':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Amusnet_16_3_2026.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'fazi-2026-03':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Fazi_27_3_2026.pdf`;
                nagrada = "5.000,00 €";
                break;
            case 'tech4bet-2026-04':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Tech4Bet_9_4_2026.pdf`;
                nagrada = "40.000,00 €";
                break;
            case 'amusnet-2026-04':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Amusnet_13_4_2026.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'promatic-2026-04':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Promatic_20_4_2026.pdf`;
                nagrada = "12.000,00 €";
                break;
            case 'evona-2026-05':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Evona_11_5_2026.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'amusnet-2026-05':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Amusnet_15_5_2026.pdf`;
                nagrada = "50.000,00 €";
                break;
            case 'fazi-2026-05':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Fazi_18_5_2026.pdf`;
                nagrada = "10.000,00 €";
                break;
            case 'egt-digital-2026-05-1':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_25_5_2026.pdf`;
                nagrada = "40.000,00 €";
                break;
            case 'tech4bet-2026-06':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Tech4Bet_1_6_2026.pdf`;
                nagrada = "40.000,00 €";
                break;
            case 'pragmaticplay-2026-06':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_PragmaticPlay_15_6_2026.pdf`;
                nagrada = "60.000,00 €";
                break;
            case 'egt-digital-2026-06':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGTDigital_19_6_2026.pdf`;
                nagrada = "80.000,00 €";
                break;
            case 'fazi-2026-06':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_Fazi_26_6_2026.pdf`;
                nagrada = "12.000,00 €";
                break;
            case 'egaming-2026-07':
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_EGamingl_16_7_2026.pdf`;
                nagrada = "6.000,00 €";
                break;
            default:
                pravila = `${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperBomba_2022_pravila.pdf`;
                nagrada = "13.272,28 €";
                break;
        }

        return (
            <div id="rewards" className="casino-superbomba-section">
                <div className="bomba-info">Provjeri koliko vrijede simboli u bombama</div>
                <div className="bomba-rewards-text">Nagradni fond SuperBombe je <span>{nagrada}</span></div>
                <div className="bombs">
                    {state.rewards.filter(x => x.nagrada >= smallBombsStart).map((rew, i) => renderBomb(rew, i))}
                </div>
                <div className="bombs-small">
                    {smallBombs.map((rew, i) => renderSmallBomb(rew, i))}
                </div>
                <a className="btn-rules" target="_blank" href={pravila + '?c=' + casino.config.guiCacheVerzija}>
                    <span>Pravila</span>
                </a>
                <p className="bold" style={{ textAlign: "center", color: "#aa0d19", fontSize: "14px" }}>Izmjenjena su pravila promocije.</p>
            </div>
        )
    }

    function renderBomb(rew, i) {
        return <div className={"bomb " + (rew.brojIskoristenihBomba > 0 ? "exploded" : "")} key={"bomb-" + i}>
            <img className="front" src="content/images/bonusi/casinosuperbomba/eksplozija/front.png"></img>
            <img className="back" src="content/images/bonusi/casinosuperbomba/eksplozija/back.png"></img>
            <img className="smoke" src="content/images/bonusi/casinosuperbomba/eksplozija/smoke.png"></img>
            <img className="parts" src="content/images/bonusi/casinosuperbomba/eksplozija/parts.png"></img>
            <img className="simbol" src={`content/images/bonusi/casinosuperbomba/simboli/${rew.code}.png`}></img>
            <img className="full-bomb final" src="content/images/bonusi/casinosuperbomba/img_bomba.png"></img>
            <div className="reward">{casino.utils.numberWithCurrencyFromated(rew.nagrada, state.info.valuta)}</div>
            {/* {rew.brojDostupnihBomba > 0 && <div className="remaining-large-bombs">{rew.brojDostupnihBomba}x</div>} */}
            <div className={"simbol-naziv " + (rew.brojIskoristenihBomba == 0 ? "blur" : "")}>{rew.naziv}</div>
        </div>
    }

    function renderSmallBomb(rew, i) {
        return <div className="row" key={"small-bomb-" + rew.code + i}>
            {rew.brojIskoristenihBomba == 0 && <img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png"></img>}
            {rew.brojIskoristenihBomba > 0 && <img src={`content/images/bonusi/casinosuperbomba/simboli/${rew.code}.png`}></img>}
            {rew.brojDostupnihBomba > 0 && <span className="remaining-bombs">{rew.brojDostupnihBomba}x</span>}
            <span className={"simbol-naziv " + (rew.brojIskoristenihBomba == 0 ? "blur" : "")}>{rew.naziv}</span>
            <span>{casino.utils.numberWithCurrencyFromated(rew.nagrada, state.info.valuta)}</span>
        </div>
    }

    function renderGlobalInfo() {
        smallBombsStart = 3000;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Black Friday SuperBomba od 13.272,28 €</div>
            <p><strong>Imamo eksplozivnu utrku za one uporne! Zaigraj specijalnu SuperBomba utrku od 25.11. (12:00h) i igraj do 28.11. (23:59h) jer tijekom utrke dijelimo bomba nagrade.</strong></p>
            <span className={"img-character " + (kampanja ? "winter" : "")}></span>
            <p className="bold title"><b>Kako igrati?</b></p>
            <p>Tijekom SuperBomba utrke <strong> zavrti bilo koju Casino igru </strong> uz minimalni iznos vrtnje od 0,27 € i slobodno igraj i ostale Casino utrke. Ukupni nagradni fond utrke je 13.272,28 €, a dobitke dijelimo nasumično. Međutim, ako više igraš povećavaš si mogućnost osvajanja nagrade.</p>
            <p className="bold title"><b>Koje su nagrade?</b></p>
            <p><strong>Dijelimo 500 bombi... Odnosno nagrada!</strong> Sve što trebaš raditi je aktivno igrati Casino igre i sudjelovati u utrci. Ako ti se na ekranu pojave bombe, odaberi jednu koju želiš aktivirati i nakon eksplozije će ti se prikazati jedan simbol. Svaki simbol vrijedi određeni iznos, a isplata nagrade je trenutna!</p>

            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <NavLink to="/">
                        <button className="action-btn">PREGLEDAJ SVE IGRE</button>
                    </NavLink>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function scrollToGames() {
        document.querySelector('#tabs').scrollIntoView({
            behavior: 'smooth'
        });
    }

    function renderMultiproviderSuperBombaInfo() {
        smallBombsStart = 500;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Nova ljetna SuperBomba – 5.000 € čeka na eksploziju!</div>
            <p><strong>Vrijeme je za pravo osvježenje uz bombastične nagrade!</strong></p>
            <p>Od <strong>14.7. u 00:00 h</strong> do <strong>18.7. u 23:59 h</strong>, pripremili smo neodoljivu priliku za osvajanje nagrada s providerima <strong>Red Tiger, Netent, BTG i No Limit City</strong>.</p>
            <p>Uključi se osvajanje <strong>SuperBombe</strong> u kojoj dijelimo <strong>300 nagrada iz fonda vrijednog 5.000 €</strong>. I najbolje od svega – <strong>nagrade se dijele nasumično</strong>! Ni iskustvo, ni brzina, ni stručnost nisu faktor u osvajanju. Što više igraš, to su ti veće šanse za osvajanje nagrade. BOOM! 💥</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 Od 14. 7. 2025. (00:00) do 18. 7. 2025 (23:59) igraj bilo koju igru <strong>Red Tiger, Netent, BTG i No Limit City providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>nagradu koja se skriva u SuperBombi</strong>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>Dijelimo <strong>300 nagrada</strong> koje su vrijedne ukupno <strong>5.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>👉 <strong>Nagradu ćemo ti odmah isplatiti na račun</strong> i možeš nastaviti s igrom.</p>
            <br></br>
            <p>Iznose i raspodjelu nagrada provjeri ispod. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderSynotSuperBombaInfo() {
        smallBombsStart = 500;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Tko hoće, neka kaže voće - dijelimo nagrade u Synot SuperBombi</div>
            <p>Voćkice nose sreću, a u Synot igrama <strong>od 25. do 31. srpnja</strong> mogu ti donijeti dodatna iznenađenja.</p>
            <p>Tijekom 7 dana zabave, <strong>igraj bilo koju Synot igru</strong> s minimalnim ulogom od <strong>0,20 € po vrtnji</strong> i možda baš ti osvojiš jednu od <strong>800 nagrada</strong> iz ukupnog nagradnog fonda od <strong>12.000 €</strong>!</p>
            <p>Nagrade se dijele nasmično, a dobitnik može postati bilo tko!</p>
            <p className="bold title"><b>Kako osvojiti SuperBombu? 🎰</b></p>
            <p>👉 <strong>Od 25. 7. (00:00) do 31. 7. (23:59)</strong> igraj bilo koju igru Synot providera uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>nagradu koja se skriva u SuperBombi</strong>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>Dijelimo <strong>800 nagrada</strong> koje su vrijedne ukupno <strong>12.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>👉 <strong>Nagradu ćemo ti odmah isplatiti na račun</strong> i možeš nastaviti s igrom.</p>
            <br></br>
            <p>Iznose i raspodjelu nagrada provjeri ispod. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalAugust2025Info() {
        smallBombsStart = 500;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Provedi vrhunac ljeta uz EGT Digital SuperBombu 🌞🌡️</div>
            <p>Sredina kolovoza je idealna za dobitke i osvajanje nagrada. U tjednu od <strong>11. do 17. 8.</strong> zaigraj <strong>EGT Digital igre</strong> i osvoji svoju <strong>SuperBombu.</strong></p>
            <p>Dijelimo <strong>1500 bombastičnih nagrada</strong> vrijednih ukupno <strong>50.000 €.</strong> Zavrti odmah jer svakim spinom si sve bliže osvajanju nagrade.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 Tijekom trajanja promocije zavrti bilo koju igru <strong>EGT Digital providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre prikaže <strong>bomba</strong>, aktiviraj je i nakon eksplozije otkrit ćeš <strong>nagradu koja se skriva u SuperBombi</strong>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 Tijekom promocije podijelit ćemo čak <strong>1500 nagrada.</strong></p>
            <p>👉 Ukupna vrijednost nagradnog fonda iznosi fenomenalnih <strong>50.000 €.</strong></p>
            <p>👉 Nagrade se dodjeljuju igračima potpuno <strong>nasumično.</strong></p>
            <p>Iznose i raspodjelu nagrada provjeri ispod. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }
    function renderTech4BetAugust2025Info() {
        smallBombsStart = 200;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Okruni se SuperBombom u Tech4Bet igrama</div>
            <p>Ne trebaš plavu krv da bi postao kralj ili kraljica zabave. Dovoljno je zaigrati <strong>Tech4Bet igre </strong>s minimalnim ulogom od <strong>0,20 € </strong>po vrtnji i možda se baš ti okruniš <strong>nasumičnom nagradom! </strong>👑</p>
            <p><strong>Od 18. do 24. 8. </strong>dijelimo čak <strong>1000 bombastičnih nagrada </strong>vrijednih ukupno <strong>20.000 €. </strong>Zavrti svoju šansu jer svakim spinom si sve bliže osvajanju minimalno jedne SuperBombe.💣</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 18. 8. (00:00) do 24. 8. (23:59) </strong>igraj <strong>Tech4Bet igre </strong>uz minimalan ulog od <strong>0,20 € </strong>po vrtnji</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>nagradu koja se skriva u SuperBombi</strong>.</p>
            <p>👉 <strong>Nagradu ćemo ti odmah isplatiti na račun </strong>i možeš nastaviti uživati u nastavku svoje <strong>Tech4Bet </strong>zabave.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 Dijelimo <strong>1000 nagrada.</strong></p>
            <p>👉 Ukupna vrijednost nagradnog fonda je <strong>20.000 €.</strong></p>
            <p>👉 SuperBombe se dodjeljuju potpuno <strong>nasumično.</strong></p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderGamesGlobalAugust2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Ljeto još nije gotovo – stiže Games Global SuperBomba! 💣🌞</div>
            <p>Kraj kolovoza rezerviran je za eksplozivnu zabavu i nagrade! U razdoblju od <strong>22. do 28. 8. </strong>zaigraj <strong>Games Global </strong>igre i osvoji svoju <strong>SuperBombu.</strong></p>
            <p>Dijelimo <strong>1000 bombastičnih nagrada</strong> ukupne vrijednosti <strong>10.000 €</strong>! Zavrti odmah jer svakim spinom si sve bliže trenutku kad se pojavi bomba s tvojom nagradom! 💥</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 Tijekom trajanja promocije zavrti bilo koju igru <strong>Games Global </strong>providera uz minimalan ulog od <strong>0,20 €</strong> po vrtnji</p>
            <p>👉 Ako ti se tijekom igre prikaže bomba – aktiviraj je! Nakon eksplozije otkrivaš iznos svoje nagrade</p>
            <p>👉 Nagrada se odmah isplaćuje na tvoj račun – bez dodatnih uvjeta i čekanja!</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 Tijekom promocije podijelit ćemo ukupno <strong>1000 nagrada</strong></p>
            <p>👉 <strong>Ukupni fond iznosi 10.000 € </strong>– spreman za osvajanje</p>
            <p>👉 Svi dobitnici se biraju <strong>potpuno nasumično </strong>– svaka vrtnja može biti dobitna!</p>
            <p>S preko <strong>300 Games Global igara</strong> u ponudi, uključujući popularne naslove poput <strong>Stars Bonanza, Cairo Connectify Pays i Bass Cash Deluxe</strong>, zabava i šansa za nagradu su ti zagarantirane!</p>
            <p>Iznose i raspodjelu nagrada provjeri ispod. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEndorphinaOctober2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Udar adrenalina uz Endorphina SuperBombe</div>
            <p>Kreće napetost i prilika za sjajne dobitke. Svaki spin može biti pravi <strong>adrenalinski udar koji otkriva nasumičnu nagradu u SuperBombi</strong>.</p>
            <p>S minimalnim ulogom od <strong>0,20 €</strong> zavrti svoju šansu za osvajanje nasumične bombe koja ti može donijeti super nagradu! <strong>500 SuperBombi</strong> pada, a svakom vrtnjom si sve bliže osvajanju jedne za sebe.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 6. 10.  (00:00) do 12. 10. (23:59)</strong> igraj odabrane Endrophina igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi nagradu <strong>određenog</strong> iznosa.</p>
            <p>👉 <strong>Nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self">Bonusima</a>.</strong></p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U Endrophina SuperBombi dijelimo <strong>500 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEndorphinaOctober2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Udar adrenalina uz Endorphina SuperBombe</div>
            <p>Kreće napetost i prilika za sjajne dobitke. Svaki spin može biti pravi <strong>adrenalinski udar koji otkriva nasumičnu nagradu u SuperBombi</strong>.</p>
            <p>S minimalnim ulogom od <strong>0,20 €</strong> zavrti svoju šansu za osvajanje nasumične bombe koja ti može donijeti super nagradu! <strong>500 SuperBombi</strong> pada, a svakom vrtnjom si sve bliže osvajanju jedne za sebe.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 6. 10.  (00:00) do 12. 10. (23:59)</strong> igraj odabrane Endrophina igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi nagradu <strong>određenog</strong> iznosa.</p>
            <p>👉 <strong>Nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self">Bonusima</a>.</strong></p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U Endrophina SuperBombi dijelimo <strong>500 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalNovember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Nema zime za SuperBomba dobitke</div>
            <p>Studeni započni s vrućom EGT Digital SuperBombom.</p>
            <p>Igraj bilo koju EGT Digital igru s minimalnim ulogom od <strong>0,20 €</strong> i zavrti svoju šansu za osvajanje nasumične nagrade!</p>
            <p>Zagrij se za početak mjeseca jer dijelimo <strong>1500 SuperBombi</strong>, a svakom vrtnjom si sve bliže osvajanju minimalno jedne nagrade za sebe.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 3. 11. (00:00) do 9. 11. (23:59)</strong> igraj EGT Digital igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U EGT Digital SuperBombi dijelimo <strong>1500 nagrada</strong> koje su vrijedne ukupno <strong>50.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p><strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderGamesGlobalNovember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Tko je za toplu nagradu u studene dane?</div>
            <p>U Games Global igrama pada 1000 SuperBombi vrijednih ukupno 20.000 €. S minimalnim ulogom od 0,20 € zavrti svoju šansu za osvajanje nasumične SuperBombe!</p>
            <p>Svakom vrtnjom si sve bliže osvajanju minimalno jedne za sebe.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 10. 11.  (00:00) do 16. 11. (23:59)</strong> igraj bilo koju <strong>Games Global igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U Games Global SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p><strong>Kad osvojiš nagradu - prihvati je u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalLateNovember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">EGT Digital donosi još SuperBombi</div>
            <p>Nastavlja se osvajanje SuperBomba nagrada u EGT Digital igrama.</p>
            <p>Iskoristi priliku i zavrti svoju šansu za nasumične nagrade! Igraj <strong>bilo koju EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i probaj osvojiti minimalno jednu nagradu za sebe!</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 17. 11.  (00:00) do 23. 11. (23:59)</strong> igraj EGT Digital igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U EGT Digital SuperBombi dijelimo <strong>1500 nagrada</strong> koje su vrijedne ukupno <strong>50.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p><strong>Kad osvojiš nagradu - prihvati je u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderAmusnetNovember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Amusnetova SuperBomba teška je 50.000 €</div>
            <p>Ne gubi vrijeme, nego iskoristi šansu i osvoji fantastične nagrade u <strong>Amusnet SuperBombi</strong>.</p>
            <p>Zavrti <strong>bilo koju Amusnet</strong> igru s minimalnim ulogom od <strong>0,20 €</strong> i osvoji nagradu iz velikog nagradnog fonda!</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 24. 11.  (00:00) do 30. 11. (23:59)</strong> igraj Amusnet igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 Dijelimo <strong>3000 nagrada</strong> ukupne vrijednosti <strong>50.000 €</strong>, a dodjeljuju se <strong>potpuno nasumično</strong>.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalEarlyDecember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Ukliži u blagdansku EGT Digital SuperBombu od 20.000 €</div>
            <p>✨ Iskoristi prvu polovicu prosinca za osvajanje blagdanskih SuperBombi! ✨</p>
            <p>Igraj bilo koju EGT Digital igru s minimalnim ulogom od <strong>0,20 €</strong> jer nasumično dijelimo 1000 SuperBombi.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 1. 12.  (00:00) do 8. 12. (23:59)</strong> igraj EGT Digital igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 U EGT Digital SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalLateDecember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Ukliži u blagdansku EGT Digital SuperBombu od 50.000 €</div>
            <p>✨ Iskoristi prvu polovicu prosinca za osvajanje blagdanskih SuperBombi! ✨</p>
            <p>Igraj bilo koju EGT Digital igru s minimalnim ulogom od <strong>0,20 €</strong> jer nasumično dijelimo 1500 SuperBombi.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 8. 12.  (00:00) do 14. 12. (23:59)</strong> igraj EGT Digital igre uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 U EGT Digital SuperBombi dijelimo <strong>1500 nagrada</strong> koje su vrijedne ukupno <strong>50.000 €</strong>, igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderPragmaticDecember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">4000 nagrada vrijednih 70.000 € dijelimo u Pragmatic Play igrama</div>
            <p><strong>✨Nova SuperBomba u SuperProsincu ✨</strong></p>
            <p>U Pragmatic Play igrama čeka te super zabava u kojoj dijelimo 4000 nagrada ukupne vrijednosti od 70.000 €.</p>
            <p>Kreni u zabavno osvajanje vrijednih nagrada!</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 11. 12.  (00:00) do 18. 12. (23:59)</strong> igraj Pragmatic Play igru s minimalanim ulogom od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 U Pragmatic Play SuperBombi dijelimo <strong>4000 nagrada</strong> koje su vrijedne ukupno <strong>70.000 €</strong>, igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderFaziDecember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">SuperProsinac daruje SuperBombama u Fazi igrama</div>
            <p><strong>Ulovi nove nagrade iz fonda od 20.000 €</strong></p>
            <p><strong>✨ SuperProsinac vrvi nagradama i novim SuperBombama! ✨</strong></p>
            <p>Igraj bilo koju Fazi igru s minimalnim ulogom od <strong>0,30 €</strong> jer nasumično dijelimo <strong>1000 SuperBombi</strong>.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 15. 12.  (00:00) do 21. 12. (23:59)</strong> igraj Fazi igre s minimalanim ulogom od <strong>0,30 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>👉 U Fazi SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderGamesGlobalDecember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Zavrti zabavu za SuperBomba nagradu u Games Global igrama</div>
            <p>I u Games Global igrama smo spremili nešto bombastično ove blagdane. Od 19. do 25. 12. dijelimo 1000 SuperBombi nasumičnih iznosa i ukupne vrijednosti 20.000 €.</p>
            <p>Igraj najdraže Games Global igre jer svakim vrtnjom si sve bliže osvajanju minimalno jedne nagrade.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 19. 12.  (00:00) do 25. 12. (23:59)</strong> igraj games Global igre s minimalnim ulogom od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U Games Global SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderPlayNGoDecember2025Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Play’n Go dijeli 1000 SuperBombi</div>
            <p><strong>Za dodatne nagrade ove blagdane igraj najdraže Play’n Go igre!</strong></p>
            <p><strong>Od 22. do 28. 12.</strong> dijelimo <strong>1000 SuperBombi</strong> nasumičnih iznosa i ukupne vrijednosti <strong>20.000 €.</strong></p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 Tijekom promocije igraj bilo koju Play’n Go igru s minimalnim ulogom od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U Play'n Go SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalJanuary2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Svi putevi vode u EGT Digital SuperBombu od 20.000 €</div>
            <p>Pred tobom je zabavan i bombastičan period lova na SuperBombe.</p>
            <p>Na putu prema nagradama od <strong>5. do 11. siječnja</strong> igraj bilo koju <strong>EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> jer nasumično dijelimo <strong>1000 SuperBombi</strong> koje su vrijedne ukupno <strong>20.000 €</strong>.</p>
            <p><strong>Kreni u lov na nagrade!</strong></p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 5. 1.  (00:00) do 11. 1. (23:59)</strong> igraj bilo koju EGT Digital igru uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj EGT Digital SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalLateJanuary2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Svi putevi vode u EGT Digital SuperBombu od 20.000 €</div>
            <p>Pred tobom je zabavan i bombastičan period lova na SuperBombe.</p>
            <p>Na putu prema nagradama <strong>od 12. do 18. siječnja</strong> igraj bilo koju <strong>EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> jer nasumično dijelimo <strong>1000 SuperBombi</strong> koje su vrijedne ukupno <strong>20.000 €</strong>.</p>
            <p><strong>Kreni u lov na nagrade!</strong></p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 12. 1.  (00:00) do 18. 1. (23:59)</strong> igraj bilo koju EGT Digital igru uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba</strong>, aktiviraj je. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj EGT Digital SuperBombi dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>👉 <strong>Ako je osvojiš, nagradu prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderGreentube2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">U Greentube SuperBombi od 2000 nagrada ti ulovi svoje</div>
            <p>Zabava tek kreće u Greentube igrama. 🎰➡️ Dijelimo 2000 SuperBombi vrijednih 40.000 €!</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 16. 1.  (00:00) do 22. 1. (23:59)</strong> igraj bilo koju <strong>Greentube igru</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi bomba - <strong>aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Greentube SuperBombi</strong> dijelimo <strong>2000 nagrada</strong> koje su vrijedne ukupno <strong>40.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function render7777Gaming2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">U 7777 igrama nižu se SuperBombe</div>
            <p>Do kraja mjeseca ulovi SuperBombe u igrama 7777 povidera 🎰➡️ Dijelimo 600 nagrada vrijednih 10.000 €. Probaj osvojiti minimalno jednu! 🤑</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 23. 1.  (00:00) do 31. 1. (23:59)</strong> igraj bilo koju <strong>igru 7777 providera</strong> uz minimalan ulog od <strong>0,10 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi bomba - <strong>aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>7777 SuperBombi</strong> dijelimo <strong>600 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalEarlyFebruary2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">EGT Digital SuperBombe dijele 1000 nagrada</div>
            <p>Veljača te poziva na zabavu uz EGT Digital igre i 20.000 € vrijedan fond. Igra je tu - odazovi se i ti šansi za osvajanje minimalno jedne od 1000 nagrada. 🤑</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 2. 2. (00:00) do 8. 2. (23:59)</strong> igraj bilo koju <strong>igru EGT Digital providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>EGT Digital SuperBombi</strong> dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderPlayNGoFebruary2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Play’n Go SuperBombe dijele super nagrade</div>
            <p>💣💥 Zaljubi se u igru, dodaj puuuno zabave u dan i doživi <strong>SuperBomba</strong> eksploziju nagrada u <strong>Play’n GO igrama</strong>. Igra je tu - odazovi se i ti šansi za osvajanje minimalno jedne od <strong>1000 nagrada</strong>. 🤑</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 12. 2. (00:00) do 15. 2. (23:59)</strong> igraj bilo koju <strong>Play’n Go providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Play’n Go SuperBombi</strong> dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalMarch2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Ožujska SuperBomba nosi nagrade</div>
            <p>😎🌷 Ožujak budi igru i pokreće nagrade. Probudi se i ti i odazovi se šansi za osvajanje minimalno jedne od <strong>1000 nagrada koje se dijele igračima</strong>. 🤑</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 2. 3. (00:00) do 8. 3. (23:59)</strong> igraj bilo koju <strong>igru EGT Digital providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>EGT Digital SuperBombi</strong> dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>20.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEvona2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Evo, SuperBombe u Evona igrama</div>
            <p>🌱☀️ Dozovi proljeće u svoju igru. Igraj Evona igre i osvoji minimalno jednu od 500 SuperBombi. Svakom vrtnjom si bliže nagradi pa zavrti svoju šansu za pobjedu! 🏆</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 9. 3. (00:00) do 15. 3. </strong> igraj bilo koju <strong>igru Evona providera</strong> uz minimalan ulog od <strong>0,10 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Evona SuperBombi</strong> dijelimo <strong>500 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderAmusnet2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Igraj i osvoji jednu od 3000 Amusnet SuperBombi</div>
            <p>🌼 Dočekaj proljeće s novom nagradom. Zavrti svoju šansu u šarenom svijetu Amusnet igara i osjeti kako svaka vrtnja cvjeta uzbuđenjem i šansom za dobitkom.</p>
            <p><strong>3000 nagrada se dijeli</strong>, a svakom vrtnjom si sve bliže osvajanju minimalno jedne. 🍀</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 16. 3. (00:00) do 23. 3. (23:59)</strong> igraj bilo koju igru <strong>Amusnet providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Amusnet SuperBombi</strong> dijelimo <strong>3000 nagrada</strong> koje su vrijedne ukupno <strong>50.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderFazi2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">U Fazi SuperBombi dijelimo 400 nagrada</div>
            <p>Nova šansa za nagradu ti je na dohvat vrtnje. Kroz <strong>5 dana zabave</strong> ulovi barem jednu od 400 SuperBomba nagrada u Fazi igrama.</p>
            <p>Do kraja ožujka zabavi se u igri s novim nagradama.🎁</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 27. 3. (00:00) do 31. 3. (23:59)</strong> igraj bilo koju igru <strong>Fazi providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Fazi SuperBombi</strong> dijelimo <strong>400 nagrada</strong> koje su vrijedne ukupno <strong>5.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderTech4BetApril2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Voćke i jokeri u Tech4Bet SuperBombi </div>
            <p>Igra koja nije samo nostalgija, nego prava akcija uz poznate simbole voćkica i jokera <strong>do 15. 4.</strong> dolaze uz šansu za <strong>dodatnu SuperBomba nagradu</strong> u <strong>Tech4Bet igrama</strong>.</p>
            <p>Bez obzira koju igru zavrtiš, jedno je sigurno - <strong>šansa za bombastičnu nagradu ti je na dohvat vrtnje</strong>.</p>
            <p>Zavrti šansu i pretvori zabavu u SuperBomba dobitak 💥</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 9. 4. (00:00) do 15. 4. (23:59)</strong> igraj bilo koju igru <strong>Tech4Bet providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Tech4Bet SuperBombi</strong> dijelimo <strong>1500 nagrada</strong> koje su vrijedne ukupno <strong>40.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderAmusnetApril2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Amusnet SuperBomba dijeli 3000 nagrada</div>
            <p>Travanj buja s nagradama, a u <strong>Amusnet SuperBombi</strong> dijelimo nagradni fond vrijedan <strong>50.000 €</strong>.</p>
            <p>Super zabava te zove! Odazovi se šansi za osvajanje minimalno jedne od 3000 nasumičnih nagrada. 🤑</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 13. 4. (00:00) do 19. 4. (23:59)</strong> igraj bilo koju igru <strong>Amusnet providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Amusnet SuperBombi</strong> dijelimo <strong>3000 nagrada</strong> koje su vrijedne ukupno <strong>50.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderPromaticApril2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Super je zabava i bomba je nagrada u Promatic SuperBombi </div>
            <p>Super zabava vrti se na <strong>Promatic </strong>spinovima. U rapsodiji ekskluzivnih igara možeš osvojiti i SuperBomba nagradu. </p>
            <p>Uključi se u igru jer <strong>od 20. do 26. travnja </strong>nagrade pršte - <strong>1000 SuperBombi </strong>dijelimo, a svakom vrtnjom sve si bliže osvajanju minimalno jedne za sebe.</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 20. 4. (00:00) do 26. 4. (23:59)</strong> igraj bilo koju igru <strong>Promatic providera</strong> uz minimalan ulog od <strong>0,10 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Promatic SuperBombi</strong> dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>12.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEvonaMay2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Evona dijeli 500 SuperBombi</div>
            <p>Igraj, zavrti i osvoji bombastične nagrade! SuperSvibanjska zabava ne staje, a ovaj tjedan na redu je provider <strong>Evona</strong> u čijim igrama dijelimo <strong>500 SuperBombi</strong>.</p>
            <p>Svakom vrtnjom si bliže osvajanju minimalno jedne nagrade pa zavrti svoju šansu za pobjedu! 🏆</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 11. 5. (09:00) do 17. 5. (23:59)</strong> igraj bilo koju igru <strong>Evona providera</strong> uz minimalan ulog od <strong>0,10 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Evona SuperBombi</strong> dijelimo <strong>500 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderAmusnetMay2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">U Amusnet SuperBombi dijelimo 3000 nagrada</div>
            <p>Sredina svibnja je bombastična, puna akcije i nagrada. 3000 razloga za igru te čeka u Amusnet igrama. Dijelimo nagradni fond vrijedan <strong>50.000 €</strong> pa uskoči u zabavu i osvoji minimalno jednu nagradu! 🤑</p>
            <p>Svakom vrtnjom si bliže osvajanju minimalno jedne nagrade pa zavrti svoju šansu za pobjedu! 🏆</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 15. 5. (09:00) do 22. 5. (23:59)</strong> igraj bilo koju igru <strong>Amusnet providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Amusnet SuperBombi</strong> dijelimo <strong>3000 nagrada</strong> koje su vrijedne ukupno <strong>50.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderFaziMay2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">U Fazi SuperBombi dijelimo 700 nagrada</div>
            <p>Uleti u Fazi SuperBombu za nagrade vrijedne 10.000 €. 💥</p>
            <p>Dijelimo <strong>700 nasumičnih SuperBombi</strong> pa kad osvojiš svoju, aktiviraj je i saznaj kakav te dobitak čeka!</p>
            <p>Igraj Fazi igre jer si time bliže svom osvajačkom boom trenutku. 💣</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 18. 5. (12:00) do 24. 5. (23:59)</strong> igraj bilo koju igru <strong>Fazi providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Fazi SuperBombi</strong> dijelimo <strong>700 nagrada</strong> koje su vrijedne ukupno <strong>10.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEgtDigitalMay2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Prasak tisuću nagrada vrijednih 40.000 € u EGT Digital SuperBombi</div>
            <p>Uključi se u prasak zabave u EGT Digital igrama u kojima dijelimo <strong>40.000 €</strong> vrijedan nagradni fond. 🎰 Čeka te <strong>1000 SuperBombi</strong> pa zaigraj <strong>bilo koju EGT Digital igru</strong> i aktiviraj šansu za osvajanje minimalno jedne nagrade.🤑</p>
            <p>Svakom vrtnjom si bliže osvajanju barem jedne nasumične nagrade.🎁 Igra neka počne! 👏</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 25. 5. (12:00) do 31. 5. (23:59)</strong> igraj bilo koju igru <strong>EGT Digital providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>EGT Digital SuperBombi</strong> dijelimo <strong>1000 nagrada</strong> koje su vrijedne ukupno <strong>40.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderTech4BetJune2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">1500 nagrada dijelimo u Tech4Bet SuperBombi</div>
            <p>Čeka te bombastična zabava. 💣 Igraj bilo koju Tech4Bet igru i probaj osvojiti minimalno jednu nagradu iz fonda vrijednog 40.000 €.</p>
            <p>🎰 Dijelimo 1500 SuperBombi pa zaigraj Tech4Bet igre i aktiviraj šansu za osvajanje minimalno jedne nagrade. 🤑</p>
            <p>Svakom vrtnjom si bliže osvajanju barem jedne nasumične nagrade.🎁</p>
            <p>Igra neka počne! 👏</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 1. 6. (09:00) do 10. 6. (23:59)</strong> igraj bilo koju igru <strong>Tech4Bet providera</strong> uz minimalan ulog od <strong>0,20 €</strong> po vrtnji.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <strong>bomba - aktiviraj je</strong>. Nakon eksplozije otkrit ćeš <strong>dobitni simbol</strong> koji ti donosi <strong>nagradu</strong> određenog iznosa.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Tech4Bet SuperBombi</strong> dijelimo <strong>1500 nagrada</strong> koje su vrijedne ukupno <strong>40.000 €</strong>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ne zaboravi - ako osvojiš nagradu, potrebno ju je <strong> prihvatiti u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderPragmaticJune2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">4000 nagrada dijelimo u Pragmatic Play igrama</div>
            <p><strong>SuperLipanj</strong> prepun zabave i igre dijeli top nagrade!
                U <strong>Pragmatic Play igrama</strong> čeka te super zabava u kojoj dijelimo <strong>4000 nagrada</strong> ukupne <strong>vrijednosti od 60.000 €</strong>.</p>
            <p>Kreni u zabavno osvajanje vrijednih nagrada! 🎰</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <b>Od 15. 6. (09:00) do 25. 6. (23:59)</b> igraj <b>Pragmatic Play</b> igre s <b>minimalnim ulogom od 0,20 € po vrtnji</b>.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <b>bomba - aktiviraj ju</b>. Nakon eksplozije otkrit ćeš <b>dobitni simbol</b> koji ti donosi <b>nagradu određenog iznosa</b>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U <b>Pragmatic Play SuperBombi</b> dijelimo <b>4000 nagrada</b> koje su <b>vrijedne ukupno 60.000 €</b>, a dodjeljuju se igračima potpuno nasumično.</p>
            <p>📣 Ako je osvojiš, nagradu <strong>prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGTDigitalJune2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Pripremi se za prasak 4000 EGT Digital SuperBombi</div>
            <p>Uključi se zabavu i osvajanje nagrada u EGT Digital igrama! 🎁 Dijelimo <strong>4000 SuperBombi vrijednih 80.000 €</strong> pa ne propusti šansu za osvajanje minimalno jedne nagrade za sebe.🤑</p>
            <p><strong>Igra neka počne!</strong> 👏 Svakom vrtnjom si bliže osvajanju barem jedne nasumične nagrade.🎁</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 19. 6. (09:00) do 28. 6. (23:59)</strong> igraj bilo koju igru <strong>EGT Digital providera</strong> a uz minimalan ulog od <strong>0,20 € po vrtnji</strong>.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <b>bomba - aktiviraj ju</b>. Nakon eksplozije otkrit ćeš <b>dobitni simbol</b> koji ti donosi <b>nagradu određenog iznosa</b>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>EGT Digital SuperBombi</strong> dijelimo <strong>4000 nagrada</strong> koje su vrijedne ukupno <strong>80.000 €</strong>, a dodjeljuju se igračima potpuno <strong>nasumično</strong>.</p>
            <p>📣 Ako je osvojiš, nagradu <strong>prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderFaziJune2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Toplinski val dijeli 800 nagrada u Fazi SuperBombi</div>
            <p>Uključi se zabavu i osvajanje <strong>800 nasumičnih SuperBombi</strong> do kraja lipnja. 🎁</p>
            <p>Dijelimo <strong>nagradni fond vrijedan 12.000 €</strong> pa ne propusti šansu za osvajanje minimalno jedne nagrade za sebe.🤑</p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 26. 6. (08:00) do 30. 6. (23:59)</strong> igraj bilo koju igru <strong>Fazi providera</strong> a uz <strong>minimalan ulog od 0,20 € po vrtnji</strong>.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <b>bomba - aktiviraj ju</b>. Nakon eksplozije otkrit ćeš <b>dobitni simbol</b> koji ti donosi <b>nagradu određenog iznosa</b>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>Fazi SuperBombi</strong> dijelimo <strong>800 nagrada</strong> koje su vrijedne ukupno <strong>12.000 €</strong>, a dodjeljuju se igračima potpuno <strong>nasumično</strong>.</p>
            <p>📣 Ako je osvojiš, nagradu <strong>prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderEGamingJuly2026Info() {
        smallBombsStart = 100;
        return (<div className="casino-superbomba-section">
            <div className="bomba-info">Aktiviraj zabavu i osvoji SuperBombu u E-Gaming igrama</div>
            <p>Pripremi se za eksploziju uzbuđenja! U <strong>E-Gaming igrama</strong> dijelimo <strong>500 SuperBombi</strong> ukupno vrijednih <strong>6.000 €</strong>. Uključi se u zabavu i ne propusti šansu za osvajanje minimalno jedne nagrade za sebe. 🎁</p>
            <p><strong>💣 Vrijeme je za SuperBombu!💥</strong></p>
            <p className="bold title"><b>Kako igrati? 🎰</b></p>
            <p>👉 <strong>Od 16. 7. (09:00) do 20. 7. (23:59)</strong> igraj bilo koju igru <strong>E-Gaming providera</strong> a uz <strong>minimalan ulog od 0,10 € po vrtnji</strong>.</p>
            <p>👉 Ako ti se tijekom igre na ekranu pojavi <b>bomba - aktiviraj ju</b>. Nakon eksplozije otkrit ćeš <b>dobitni simbol</b> koji ti donosi <b>nagradu određenog iznosa</b>.</p>
            <br></br>
            <p className="bold title"><b>Koje su nagrade? 🎁</b></p>
            <p>U ovoj <strong>E-Gaming SuperBombi</strong> dijelimo <strong>500 nagrada</strong> koje su vrijedne ukupno <strong>6.000 €</strong>, a dodjeljuju se igračima potpuno <strong>nasumično</strong>.</p>
            <p>📣 Ako je osvojiš, nagradu <strong>prihvati u svom Casino računu u <a href="https://casino.supersport.hr/racun/bonusi" target="_self" style={{ color: '#aa0d19' }}>Bonusima</a>.</strong></p>
            <p>👉 Iznose i raspodjelu nagrada možeš pronaći u nastavku. 👇</p>
            <div className="cta">
                <span><img src="content/images/bonusi/casinosuperbomba/img_bomba_square.png" /></span>
                <span>
                    <img src="content/images/bonusi/casinosuperbomba/ic_play_games_home.png"></img>
                    <button className="action-btn" onClick={(e) => { e.preventDefault(); scrollToGames() }}>ZAIGRAJ</button>
                </span>
            </div>
            <div className="divider"></div>
        </div>)
    }

    function renderInfo() {
        switch (kampanja) {
            case 'multi-2025-07':
                return renderMultiproviderSuperBombaInfo();
            case 'synot-2025-07':
                return renderSynotSuperBombaInfo();
            case 'egt-digital-2025-08':
                return renderEGTDigitalAugust2025Info();
            case 'tech4bet-2025-08':
                return renderTech4BetAugust2025Info();
            case 'gamesglobal-2025-08':
                return renderGamesGlobalAugust2025Info();
            case 'endorphina-2025-10':
                return renderEndorphinaOctober2025Info();
            case 'fazi-2025-10':
                return renderFaziOctober2025Info();
            case 'egt-digital-2025-11':
                return renderEGTDigitalNovember2025Info();
            case 'gamesglobal-2025-11':
                return renderGamesGlobalNovember2025Info();
            case 'egt-digital-2025-11-2':
                return renderEGTDigitalLateNovember2025Info();
            case 'amusnet-2025-11':
                return renderAmusnetNovember2025Info();
            case 'egt-digital-2025-12':
                return renderEGTDigitalEarlyDecember2025Info();
            case 'egt-digital-2025-12-2':
                return renderEGTDigitalLateDecember2025Info();
            case 'pragmatic-2025-12':
                return renderPragmaticDecember2025Info();
            case 'fazi-2025-12':
                return renderFaziDecember2025Info();
            case 'gamesglobal-2025-12':
                return renderGamesGlobalDecember2025Info();
            case 'playn-go-2025-12':
                return renderPlayNGoDecember2025Info();
            case 'egt-digital-2026-01-1':
                return renderEGTDigitalJanuary2026Info();
            case 'egt-digital-2026-01-2':
                return renderEGTDigitalLateJanuary2026Info();
            case 'greentube-2026-01':
                return renderGreentube2026Info();
            case '7777gaming-2026-01':
                return render7777Gaming2026Info();
            case 'egt-digital-2026-02-1':
                return renderEGTDigitalEarlyFebruary2026Info();
            case 'playn-go-2026-02':
                return renderPlayNGoFebruary2026Info();
            case 'egt-digital-2026-03':
                return renderEGTDigitalMarch2026Info();
            case 'evona-2026-03':
                return renderEvona2026Info();
            case 'amusnet-2026-03':
                return renderAmusnet2026Info();
            case 'fazi-2026-03':
                return renderFazi2026Info();
            case 'tech4bet-2026-04':
                return renderTech4BetApril2026Info();
            case 'amusnet-2026-04':
                return renderAmusnetApril2026Info();
            case 'promatic-2026-04':
                return renderPromaticApril2026Info();
            case 'evona-2026-05':
                return renderEvonaMay2026Info();
            case 'amusnet-2026-05':
                return renderAmusnetMay2026Info();
            case 'fazi-2026-05':
                return renderFaziMay2026Info();
            case 'egt-digital-2026-05-1':
                return renderEgtDigitalMay2026Info();
            case 'tech4bet-2026-06':
                return renderTech4BetJune2026Info();
            case 'pragmaticplay-2026-06':
                return renderPragmaticJune2026Info();
            case 'egt-digital-2026-06':
                return renderEGTDigitalJune2026Info();
            case 'fazi-2026-06':
                return renderFaziJune2026Info();
            case 'egaming-2026-07':
                return renderEGamingJuly2026Info();
            default:
                return renderGlobalInfo();
        }
    }

    return (
        <div>
            <MetaTags title="Promocije - SuperSport CASINO" description="Superbomba u SuperSport CASINU!" />
            <Header key="header" {...props}></Header>
            {state.info && <CasinoSuperbombaBanner info={state.info} kampanja={kampanja} />}
            <div className='white-background'>
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile">
                    {renderInfo()}
                    {renderRewards()}
                    <CasinoSuperbombaResults {...props} {...state} kampanja={kampanja} />
                </div>
            </div>
            {kampanja && <GameDetails loadGames={true} {...props} {...state} routePrefix={"/promotions/casino-superbomba/" + kampanja}></GameDetails>}
            <ObavijestiCasino {...props}></ObavijestiCasino>
        </div>
    )
}